
import { mapGetters } from 'vuex'
export default {
    props: {
        blockData: {
            type: String,
            default: '{}',
        },
    },

    async fetch() {
        if (!this.model.specificContent) return
        let endpoint

        switch (this.model.contentType.id) {
            case 'posses':
                endpoint = 'public/users?status=posse&'
                break

            case 'authors':
                endpoint = 'public/users?status=authors&'
                break

            case 'users':
                endpoint = 'public/users?status=all&'
                break

            case 'files':
                endpoint = 'exclusive_files?status=published&'
                break

            default:
                endpoint = `content/list/?content_type=${this.model.contentType.slug}&`
        }
        try {
            await this.$axios.get(`/api/v1/${endpoint}${this.contentQuery}`).then((res) => {
                this.contentList = res.data.data
            })
        } catch (e) {}
    },

    data() {
        return {
            contentList: [],
        }
    },

    computed: {
        ...mapGetters({ isPremiumUser: 'user/isPremiumUser' }),

        model() {
            return this.blockData ? JSON.parse(unescape(this.blockData)) : {}
        },

        contentQuery() {
            return this.model.contentList
                .map((el, index) => {
                    return `${index === 0 ? '' : '&'}id[]=${el.id}`
                })
                .join('')
        },

        columnClass() {
            return this.contentList.length < 3 ? `md:grid-cols-${this.contentList.length}` : `md:grid-cols-3`
        },

        extraQuery() {
            const extraQuery = {}
            try {
                const values = this.model.query || ''
                if (values && (typeof values === 'string' || values instanceof String) && values !== '') {
                    values.split(',').forEach((x) => {
                        const v = x.split('=')
                        if (v && v.length === 2) extraQuery[v[0]] = v[1]
                    })
                }
            } catch (e) {}
            return extraQuery
        },
    },
}
